import script from "./CourseVideoDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseVideoDetail.vue?vue&type=script&setup=true&lang=js"

import "./CourseVideoDetail.vue?vue&type=style&index=0&id=70ceea0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ceea0c"]])

export default __exports__